import antLocale from 'ant-design-vue/es/locale-provider/zh_CN'
import 'moment/locale/zh-cn'
import setting from './zh-CN/setting'
import ui from './zh-CN/messages.json'

export default { antLocale, momentName: 'zh-cn', message: '-', ...setting, ui }
